import { render, staticRenderFns } from "./InformationContainer.vue?vue&type=template&id=17bf06dd&scoped=true&"
import script from "./InformationContainer.vue?vue&type=script&lang=js&"
export * from "./InformationContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bf06dd",
  null
  
)

export default component.exports